import VueX from '@/store';

export default (to, from, next,) => {
  const redirect = to.name.indexOf('franchise',) < 0 ? '/franquias' : '/franquia';
  if (!VueX.getters['user/user']?.
    permissions.some((permission,) => permission.name.indexOf('COUPON',) >= 0,)) {
    next(redirect,);
  } else {
    next();
  }
};
